import React from 'react';

import { MenuItemsContext } from './MenuItemsContext';

export const useMenuItemsContext = () => React.useContext(MenuItemsContext);
